import { render, staticRenderFns } from "./extrafields-import.vue?vue&type=template&id=2f973a18"
import script from "./extrafields-import.vue?vue&type=script&lang=js"
export * from "./extrafields-import.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports